export enum StepStatus {
  INCOMPLETE = "INCOMPLETE", // has nothing
  MISSING_PRIMARY = "MISSING_PRIMARY", // has secondary
  MISSING_SECONDARY = "MISSING_SECONDARY", // has primary
  FAILURE = "FAILURE", // one or more has failed
  PENDING = "PENDING",
  UNRESOLVED = "UNRESOLVED", // avm action required
  COMPLETE = "COMPLETE", // all complete
}
